<template>
  <div>
    <Dropdown
      v-model="valueModel"
      :options="options"
      :auto-scroll="true"
      prepended-placeholder=" "
      placeholder="*State"
      :hide-placeholder="true"
      :error="error"
      has-search
      :bright="bright"
      :search-value="value.name"
      @open="openAndFocus"
      @close="closeAndBlur"
    />
    <div
      v-show="error.length > 0"
      class="mt-1 text-xs error-message text-ma-error"
      v-text="error"
    />
  </div>
</template>

<script>
import Dropdown from '../dropdown';

export default {
  components: {
    Dropdown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: String,
      default: '',
    },
    states: {
      type: Array,
      default: () => [],
    },
    bright: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    openAndFocus() {
      this.$emit('open');
      this.$emit('onFocus');
    },
    closeAndBlur() {
      this.blurHandle();
      this.$emit('close');
      this.$emit('onBlur');
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.currentState.slug || this.currentState.code || '';
      },
      set(value) {
        this.$emit('input', this.states.find(item => item.code === value));
      },
    },
    options() {
      return this.states.map(state => ({
        id: state.id,
        slug: state.code,
        name: state.name,
      }));
    },
    currentState() {
      if (this.value.name) {
        const currentState = this.states.find(state => state.name === this.value.name);
        return currentState;
      }
      return this.value;
    },
    validate() {
      return this.states.some(item => item.code === this.value.slug || item.code === this.currentState.code);
    },
  },
};
</script>

<style scoped>
input.error {
  border-color: #ee5951;
}
input.error + .floating-label,
.error-icon,
.error-message {
  color: #ee5951;
}
</style>
